import { render, staticRenderFns } from "./PERBELANJAAN.vue?vue&type=template&id=636bbae4"
import script from "./PERBELANJAAN.vue?vue&type=script&lang=js"
export * from "./PERBELANJAAN.vue?vue&type=script&lang=js"
import style0 from "./PERBELANJAAN.vue?vue&type=style&index=0&id=636bbae4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports